module.exports = __webpack_public_path__ + "media/images/icon__prize@3x-541ffa0d64db8c917008a2deb9cbb8a0.png";